import { Typography } from "@material-ui/core"
import { useIsDesktop } from "common/MediaQueries"
import styled from "styled-components"
import {
  StyledBody,
  StyledBody2,
  StyledHeaderH2,
  StyledLi,
  StyledLink,
  StyledUl,
} from "../../../reusable/wrappers/BodyText"

const StyledWrapper = styled.div`
  li {
    font-size: 18px;
  }
`

const StyledHeaderSubtitle = styled(Typography).attrs({
  variant: "subtitle1",
})<{
  $margin?: number
}>`
  margin-top: ${(p) => p.$margin && `${p.$margin}px`};
`

const StyledUlText = styled.ol`
  list-style-type: none;
  padding: 0px;
`
const StyledLiText = styled.li`
  font-size: 18px;
  margin-top: 10px;
`
const WarrantyBody = () => {
  const isDesktop = useIsDesktop()
  return (
    <StyledWrapper>
      <StyledHeaderH2 $position="right" $margin={40}>
        אחריות מוגבלת לרכב חדש
      </StyledHeaderH2>

      <StyledBody>
        מה מציעה האחריות המוגבלת לרכב חדש חברת מאזדה מעניקה לבעלים של רכב חדש
        מתוצרת מאזדה, אחריות לכך שהרכב חופשי מפגמים שמקורם בחומר לקוי או בעבודה
        לקויה, בכפוף לתנאים שלהלן.
      </StyledBody>
      <StyledBody>
        חברת, MAZDA MOTOR CORPORATION באמצעות דלק מוטורס או מוסך שירות מורשה
        מטעמה, תבצע את כל התיקונים הדרושים לצורך תיקון פגם שמקורו בחומר או
        בייצור, תוך שימוש בחלקים חדשים או משוקמים, ללא חיוב בעל/י הרכב.
      </StyledBody>
      <StyledHeaderSubtitle $margin={40}>
        1. ישימות האחריות
      </StyledHeaderSubtitle>

      <StyledBody>
        כתב האחריות מתייחס לרכב מתוצרת מאזדה שנרשם ומופעל בישראל. במהלך תקופת
        האחריות ניתן להעבירה לבעלים הבאים של הרכב.
      </StyledBody>

      <StyledHeaderSubtitle $margin={40}>2. תקופת האחריות</StyledHeaderSubtitle>
      <StyledBody>
        כיסוי האחריות המוענק על-ידי חברת מאזדה (MAZDA MOTOR CORPORATION) במסגרת
        האחריות המוגבלת לרכב חדש, היא לתקופה של 24 חודשים ללא הגבלת מרחק נסיעה
        מצטבר, החל מן היום בו נמסר הרכב החדש לבעליו. בתום התקופה בת 24 חודשים
        הראשונים, באם הרכב טרם גמא 100,000 ק"מ, תימשך תקופת האחריות לתקופה בת 12
        חודשים נוספים, עד לתום 36 חודשים ממועד מסירת הרכב החדש לבעליו או עד הגיע
        הרכב למרחק נסיעה מצטבר של 100,000 ק"מ ממועד מסירת הרכב החדש לבעליו
        (המוקדם מבניהם).
      </StyledBody>
      <StyledHeaderSubtitle $margin={40}>
        אחריות לקרר (גז הקירור) שבמערכת המיזוג
      </StyledHeaderSubtitle>
      <StyledBody>
        הקרר (גז הקירור) שבמערכת המיזוג מכוסה לתקופה של 12 החודשים הראשונים אלא
        אם הוחלף במערכת זו פריט המצריך מילוי גז נוסף במסגרת תיקון באחריות.
      </StyledBody>
      <StyledHeaderSubtitle $margin={40}>
        מנגנון ההנעה של נגן קלטות ונגן מקוריים (CD) תקליטורים
      </StyledHeaderSubtitle>
      <StyledBody>
        מנגנון ההנעה של נגן קלטות ונגן תקליטורים (CD) מכוסה לתקופה של 12 החודשים
        הראשונים ללא הגבלת מרחק נסיעה מצטבר.
      </StyledBody>
      <StyledHeaderSubtitle $margin={40}>מצבר</StyledHeaderSubtitle>
      <StyledBody>
        המצבר המקורי מכוסה למשך 24 חודשים החל מן היום בו נרשם הרכב במשרד הרישוי
        רישום ראשוני, ללא הגבלת מרחק נסיעה מצטבר.
      </StyledBody>
      <StyledHeaderSubtitle $margin={40}>
        האחריות לרכב לא תחול על פגם שנוצר עקב אחד או יותר מאלה:
      </StyledHeaderSubtitle>
      <StyledUlText>
        <StyledLiText>
          1. התקנה ברכב של מוצר תעבורה שאינו עומד בדרישות איכות והתאמה אם ההתקנה
          בוצעה במוסך שאינו מוסך שירות מורשה על-ידי דלק מוטורס.
        </StyledLiText>
        <StyledLiText>
          2. שירות שניתן לרכב בניגוד להוראות יצרן הרכב על-ידי מוסך שאינו מוסך
          שירות מורשה על-ידי דלק מוטורס.
        </StyledLiText>
        <StyledLiText>
          {" "}
          3. אי-עמידה בהוראות יצרן הרכב באשר לטיפולים התקופתיים ברכב, קיומם או
          מועדם.
        </StyledLiText>
        <StyledLiText>
          {" "}
          4. תיקונים או התקנת חלפים שאינם עומדים בדרישות איכות והתאמה.
        </StyledLiText>
      </StyledUlText>

      <StyledHeaderSubtitle $margin={40}>
        מה אינו מכוסה באחריות המוגבלת לרכב חדש
      </StyledHeaderSubtitle>
      <StyledUlText>
        <StyledLiText>
          נזק או שיתוך שמקורם בשימוש ברכב לא למטרות להן נועד, בתאונות או בשינויי
          מבנה או דיגום
        </StyledLiText>
        <StyledLiText>
          1. התקנה ברכב של מוצר תעבורה שאינו עומד בדרישות איכות והתאמה אם ההתקנה
          בוצעה במוסך שאינו מוסך שירות מורשה על-ידי דלק מוטורס.
        </StyledLiText>
        <StyledLiText>
          {" "}
          2. שירות שניתן לרכב בניגוד להוראות יצרן הרכב על-ידי מוסך שאינו מוסך
          שירות מורשה על-ידי דלק מוטורס.
        </StyledLiText>
        <StyledLiText>
          {" "}
          3. אי-עמידה בהוראות יצרן הרכב באשר לטיפולים התקופתיים ברכב, קיומם או
          מועדם.
        </StyledLiText>
        <StyledLiText>
          {" "}
          4. תיקונים או התקנת חלפים שאינם עומדים בדרישות איכות והתאמה.
        </StyledLiText>
      </StyledUlText>

      <StyledHeaderSubtitle $margin={40}>
        נזק או שיתוך ("קורוזיה") במשטחים, שמקורם בהשפעות סביבתיות
      </StyledHeaderSubtitle>
      <StyledUlText>
        <StyledLiText>
          {" "}
          1. כגון גשם חומצי, חומרים הנישאים באוויר (חומרים כימיים, שרף עצים,
          לשלשת ציפורים וכד'), פגיעות אבנים, מלח, סיכוני הכביש, ברד, סופה, ברק,
          הצפה, שיטפון ואירועי כוח עליון אחרים.
        </StyledLiText>
      </StyledUlText>

      <StyledHeaderSubtitle $margin={40}>
        נזק עקב היעדר תחזוקה ואי ביצוע טיפול/ים תקופתי/ים או עקב שימוש בדלק,
        בנוזלים או בחומרי סיכה בלתי מתאימים
      </StyledHeaderSubtitle>
      <StyledUlText>
        <StyledLiText>
          1. כגון גשם חומצי, חומרים הנישאים באוויר (חומרים כימיים, שרף עצים,
          לשלשת ציפורים וכד'), פגיעות אבנים, מלח, סיכוני הכביש, ברד, סופה, ברק,
          הצפה, שיטפון ואירועי כוח עליון אחרים.
        </StyledLiText>
        <StyledLiText>2. היעדר תחזוקה תקינה כפי שמוסבר בספר הנהג.</StyledLiText>
        <StyledLiText>
          {" "}
          3. תחזוקה לקויה, שימוש בדלק, שמן, נוזלים או חומרי סיכה בלתי מתאימים
          כמפורט בספר הנהג.
        </StyledLiText>
        <StyledLiText>
          {" "}
          4. נזק הנובע מביצוע טיפולים על-ידי מי שאינו מוסך שירות מורשה מטעם דלק
          מוטורס.
        </StyledLiText>
        <StyledLiText>
          {" "}
          5.נזק הנובע מאי ביצוע טיפול/ים תקופתי/ים במועדם (בהתאם להוראות בספר
          הנהג).
        </StyledLiText>
      </StyledUlText>
      <StyledHeaderSubtitle $margin={40}>בלאי רגיל</StyledHeaderSubtitle>
      <StyledUlText>
        <StyledLiText>
          {" "}
          1. בלאי, שחיקה או בלייה רגילים כגון אבדן צבע, דהייה, עיוות, טשטוש
          וכד'.
        </StyledLiText>
        <StyledLiText>
          {" "}
          2. שיתוך חיצוני על כל חלק שהוא מלבד לוחות פחי המרכב, אשר מעניקים לרכב
          מתוצרת מאזדה את עיצובו החיצוני.
        </StyledLiText>
      </StyledUlText>

      <StyledHeaderSubtitle $margin={40}>
        עלויות תחזוקה שוטפת
      </StyledHeaderSubtitle>
      <StyledUlText>
        <StyledLiText>
          {" "}
          1. עלויות תחזוקה שוטפת כגון ניקוי וליטוש ("פוליש"), סיכה ומילוי או
          החלפה של שמנים, נוזלים, נוזל קירור וכן להבי מגבים, רצועות הנעה,
          נתיכים, מסננים, רפידות בלם, רפידות המצמד, מיסב המצמד וטס הלחץ של
          המצמד, מצתים, נוריות מכל סוג, חריטת דסקיות, צלחות בלמים, כיוון זוויות
          ציר קדמי וציר אחורי, איזון גלגלים, הצלבות גלגלים וכד' שהחלפתם נובעת
          מבלאי ושחיקה רגילים.
        </StyledLiText>
        <StyledLiText>
          2. שירותי התחזוקה המתוארים בפרק "תחזוקה" או "טיפוח מראה המכונית" של
          ספר הנהג.
        </StyledLiText>
      </StyledUlText>
      <StyledHeaderSubtitle $margin={40}>
        שינוי קריאת האודומטר
      </StyledHeaderSubtitle>
      <StyledUlText>
        <StyledLiText>
          1. כל תיקון של רכב מתוצרת מאזדה שבוצע בו שינוי של קריאת האודומטר או
          שבו לא ניתן לקבוע בוודאות את מרחק הנסיעה המצטבר.
        </StyledLiText>
      </StyledUlText>
      <StyledHeaderSubtitle $margin={40}>
        הוצאות נוספות ונזקים תוצאתיים
      </StyledHeaderSubtitle>
      <StyledUlText>
        <StyledLiText>
          {" "}
          1. כל אבדן כלכלי. במסגרת זו נכללים, ללא כל הגבלה שהיא, גם עלויות הפסד
          השימוש ברכב מתוצרת מאזדה, עלויות גרירה, לינה, שכירת רכב, עלויות נסיעה,
          אבדן שכר וכל הוצאה או נזק אחרים.
        </StyledLiText>

        <StyledLiText>2. רכיבים המכוסים באחריות נפרדת • צמיגים.</StyledLiText>
      </StyledUlText>
      <StyledHeaderSubtitle $margin={40}>
        האחריות לצמיגים המקוריים המותקנים במכוניות מאזדה ניתנת על-ידי יצרן
        הצמיגים, ואינה ניתנת על-ידי חברת מאזדה. אם נתגלו פגמים בצמיגים ניתן
        לפנות לאגף השירות של דלק מוטורס לקבלת סיוע בפנייה ליצרן הצמיגים.
      </StyledHeaderSubtitle>
      <StyledUlText>
        <StyledLiText>
          1. חלקי חילוף מקוריים של מאזדה המותקנים על-ידי מוסך שירות מורשה מטעם
          דלק מוטורס (עיין בנושא "אחריות מוגבלת של מאזדה לחלקי חילוף", להלן
          במסמך זה).
        </StyledLiText>
        <StyledLiText>
          2. אחריות לאביזרים המותקנים בישראל (כגון מערכות שמע ואזעקה ומיתקונים)
          ניתנת על-ידי מרכיב הציוד.
        </StyledLiText>
      </StyledUlText>
      <StyledHeaderH2 $position="right" $margin={40}>
        חובות בעל הרכב
      </StyledHeaderH2>
      <StyledHeaderSubtitle $margin={20}>תפעול ותחזוקה</StyledHeaderSubtitle>
      <StyledUlText>
        <StyledLiText>
          על בעל הרכב מוטלת האחריות לתפעל את הרכב ולטפל בו בהתאם להנחיות
          המפורטות בספר הנהג. כמו-כן, על בעל הרכב לשמור הוכחות המעידות כי בוצעו
          כנדרש טיפולי תחזוקה נאותים ובמועד לשמירה על כיסוי האחריות.
        </StyledLiText>
        <StyledLiText>
          ביצוע הטיפולים התקופתיים יאושר בחוברת זו בחותמת ובחתימת מוסך השירות
          המורשה. על בעל הרכב לשמור את כל הקבלות ולהציג אותן במקרה בו יתעוררו
          שאלות ביחס לטיפולי תכנית התחזוקה.
        </StyledLiText>
        <StyledLiText>
          בעל רכב שקיבל שירות במוסך שאינו מוסך שירות מורשה מטעם דלק מוטורס, חייב
          להציג לדלק מוטורס, באם תבקש זאת, בהתעורר מחלוקת באשר לתוקפה של האחריות
          לרכב, חשבוניות ערוכות בהתאם לנדרש על פי תקנות רישוי שירותים ומקצועות
          בענף הרכב (סירוב לתת שירות), התשע"ז – 2017 , לסעיפים 16 (א) ו - 16 (ב)
          לצו הפיקוח על מצרכים ושירותים (ייצור מוצרי תעבורה והסחר בהם), התשמ"ג -
          1983, אשר נתן לו מוסך כאמור בגין השירות לרכב. על החשבוניות לכלול פרטים
          שיאפשרו לדלק מוטורס לבחון באם מוצרי התעבורה נשוא החשבוניות עומדים
          בדרישות איכות והתאמה שקבע יצרן הרכב.
        </StyledLiText>
      </StyledUlText>
      <StyledHeaderSubtitle $margin={40}>
        שירות המוענק במסגרת האחריות לרכב יינתן רק במוסך שירות מורשה מטעם חברת
        דלק מוטורס.
      </StyledHeaderSubtitle>
      <StyledBody>
        אם הרכב מופעל בתנאי נסיעה קשים, על בעל הרכב לפעול בהתאם לדרישות התחזוקה
        הנוספות המפורטות בספר הנהג ("תנאי נסיעה קשים" משמעותם פעולה באזורים
        מאובקים מאוד, בטמפרטורות סביבה נמוכות או במשטר נסיעה הכולל נסיעות קצרות
        רבות בהן המנוע אינו מצליח להגיע לטמפרטורת העבודה הרגילה שלו). מומלץ לבצע
        את כל טיפולי תוכנית התחזוקה והתיקונים הנדרשים במוסך שירות מורשה מטעם דלק
        מוטורס.
      </StyledBody>

      <StyledHeaderSubtitle $margin={40}>
        קבלת שירות במסגרת האחריות
      </StyledHeaderSubtitle>
      <StyledBody>
        לשם קבלת שירות במסגרת האחריות יש לפנות עם הרכב — בשעות העבודה המקובלות —
        למוסך שירות מורשה מטעם דלק מוטורס ולהציג את חוברת האחריות. כל מוסך שירות
        מורשה מטעם דלק מוטורס יבצע את השירות במסגרת האחריות בכפוף לתנאיה.
      </StyledBody>

      <StyledHeaderSubtitle $margin={40}>תנאים אחרים</StyledHeaderSubtitle>
      <StyledUlText>
        <StyledLiText>
          כל האחריויות מכללא מוגבלות בהתאמה למשך התוקף של אחריות זו.
        </StyledLiText>
        <StyledLiText>
          אחריות היצרן מחליפה ומבטלת את כל שאר האחריויות המפורשות (למעט אלה
          המוגדרות בנפרד בחוברת "מידע לגבי אחריות ורישום טיפולים") שניתנו על-ידי
          מאזדה, מפיץ מאזדה או סוכן מאזדה ממנו נרכש הרכב. אף מפיץ, סוכן או עובד
          שלהם אינו רשאי להרחיב או להגדיל אחריות זו. מאזדה ו/או דלק מוטורס לא
          ישאו בחבות כלשהי בגין נזק נלווה, מיוחד, תוצאתי או פיצויי עונשין וכן לא
          תחול כל חבות בגין שירות כלשהו שלא הוענק במפורש במסגרת אחריות זו.
        </StyledLiText>
        <StyledLiText>
          התנאים של כתב אחריות זה אינם פוגעים בזכויות על-פי דין של אנשים שרכשו
          רכב מתוצרת מאזדה.
        </StyledLiText>
      </StyledUlText>

      <StyledHeaderSubtitle $margin={40}>
        אחריות מוגבלת לפגיעות חירור עקב שיתוך חודר
      </StyledHeaderSubtitle>
      <StyledUlText>
        <StyledLiText>
          כל האחריויות מכללא מוגבלות בהתאמה למשך התוקף של אחריות זו.
        </StyledLiText>
        <StyledLiText>
          חברת מאזדה אחראית לכך כי הצבע ולוחות הפח של המרכב ברכב המאזדה החדש שלך
          — למעט משטחי הגחון וכן (עבור רכב מסחרי) המשטחים הפנימיים של ארגז נשיאת
          המטען — יהיו חופשיים מפגמים שמקורם בחומר לקוי או בעבודה לקויה, בכפוף
          לתנאים שלהלן. מוסך שירות מורשה מטעם דלק מוטורס יתקן — ללא חיוב — נזקי
          צבע ו/או פגיעות שיתוך במשטחים אשר נגרמו עקב חומר לקוי, והופיעו בתנאי
          שימוש רגילים.
        </StyledLiText>
      </StyledUlText>

      <StyledHeaderH2 $position="right" $margin={40}>
        אחריות מוגבלת לצבע ולפגיעות שיתוך במשטחים
      </StyledHeaderH2>
      <StyledBody>
        חברת מאזדה אחראית לכך כי הצבע ולוחות הפח של המרכב ברכב המאזדה החדש שלך —
        למעט משטחי הגחון וכן (עבור רכב מסחרי) המשטחים הפנימיים של ארגז נשיאת
        המטען — יהיו חופשיים מפגמים שמקורם בחומר לקוי או בעבודה לקויה, בכפוף
        לתנאים שלהלן. מוסך שירות מורשה מטעם דלק מוטורס יתקן — ללא חיוב — נזקי
        צבע ו/או פגיעות שיתוך במשטחים אשר נגרמו עקב חומר לקוי, והופיעו בתנאי
        שימוש רגילים.
      </StyledBody>
      {isDesktop && (
        <>
          <StyledHeaderSubtitle $margin={20}>
            ישימות האחריות המוגבלת לצבע ולפגיעות שיתוך במשטחים
          </StyledHeaderSubtitle>
          <StyledUlText>
            <StyledLiText>
              האחריות מתייחסת לרכב מתוצרת מאזדה שנרשם ומופעל בישראל.
            </StyledLiText>
            <StyledLiText>
              במהלך תקופת האחריות ניתן להעבירה לבעלים הבאים של הרכב.
            </StyledLiText>
          </StyledUlText>
        </>
      )}
      {!isDesktop && (
        <>
          <StyledBody $margin={20}>
            ישימות האחריות המוגבלת לצבע ולפגיעות שיתוך במשטחים
          </StyledBody>
          <StyledUl $padding={25}>
            <StyledLi $margin={20}>
              האחריות מתייחסת לרכב מתוצרת מאזדה שנרשם ומופעל בישראל.
            </StyledLi>
            <StyledLi $margin={20}>
              במהלך תקופת האחריות ניתן להעבירה לבעלים הבאים של הרכב.
            </StyledLi>
          </StyledUl>
        </>
      )}
      <StyledHeaderSubtitle $margin={40}>תקופת האחריות</StyledHeaderSubtitle>

      <StyledBody>
        היא 36 חודשים ללא הגבלת מרחק נסיעה מצטבר, החל מן היום בו נמסר הרכב החדש
        לבעליו.
      </StyledBody>
      <StyledBody>
        סוגי הרכב מתוצרת מאזדה להם מוענק כיסוי במסגרת אחריות זו — רכב פרטי ורכב
        מסחרי.
      </StyledBody>
      <StyledBody>
        האחריות מוגבלת לצבע ולפגיעות שיתוך במשטחים ואינה מכסה את אחד או יותר
        מאלה
      </StyledBody>
      <StyledUl $padding={20}>
        <StyledLi $margin={20}>
          כל נזק לצבע ו/או פגיעת שיתוך במשטח של רכב מתוצרת מאזדה אשר מקורם
          בחומרים תעשיתיים הנישאים באוויר, בתאונה, בנזק מפגיעה חיצונית, בפגיעות
          אבנים, בשימוש ברכב שלא למטרות להן נועד ובביצוע שינויים ברכב.
        </StyledLi>
        <StyledLi $margin={20}>
          השפעות סביבתיות, כגון גשם חומצי, חומרים הנישאים באוויר (כדוגמת חומרים
          כימיים, שרף עצים, לשלשת ציפורים וכד').
        </StyledLi>
        <StyledLi $margin={20}>
          כל נזק לצבע ו/או פגיעה במשטח אשר מקורם בפגיעות אופייניות של חול, ברד,
          הצפה, שיטפון, אבנים וכוח עליון אחר.
        </StyledLi>
        <StyledLi $margin={20}>
          כל נזק לצבע ו/או פגיעת שיתוך במשטח של רכב מתוצרת מאזדה אשר נגרמו לא
          כתוצאה מחומר לקוי או עבודה לקויה אלא עקב אי הענקת טיפול לרכב בהתאם
          להנחיות המפורטות בסעיף 5 להלן ולהנחיות המפורטות בספר הנהג המסופק עם
          הרכב.
        </StyledLi>
        <StyledLi $margin={20}>
          כל שיתוך חיצוני בחלק של רכב מתוצרת מאזדה שאינו לוח פח של המרכב. למען
          הסר ספק, הביטוי "לוח פח של המרכב" אינו כולל במפורש את כל הרכיבים
          המהווים חלק ממערכת הפליטה של רכב מתוצרת מאזדה.
        </StyledLi>
        <StyledLi $margin={20}>
          כל נזק לצבע ו/או פגיעת שיתוך חיצונית בחלק(ים) של רכב מתוצרת מאזדה אשר
          תוקנו לא בהתאם להנחיות המפורטות במפרטי מאזדה המופיעים בספרות הטכנית
          הישימה של מאזדה ו/או תוך שימוש בחלקים שאינם עומדים בדרישות איכות
          והתאמה.
        </StyledLi>
      </StyledUl>
      <StyledHeaderSubtitle $margin={40}>חובות בעל הרכב</StyledHeaderSubtitle>
      <StyledUl $padding={20}>
        <StyledLi $margin={20}>
          על בעל הרכב לטפל במכונית המאזדה כמפורט בנושא "טיפוח מראה המכונית" בספר
          הנהג.
        </StyledLi>
        <StyledLi $margin={20}>
          על בעל הרכב מוטלת החובה לשמור הוכחות המעידות כי בוצעו טיפולי תחזוקה
          תקינים ובמועד במכונית המאזדה שלו. ביצוע הטיפולים יאושר בחוברת האחריות
          ורישום הטיפולים בחותמת ובחתימת מוסך השירות המורשה מטעם דלק מוטורס בו
          בוצעו הטיפולים ו/או על בעל הרכב לשמור את החשבונית כאמור בסעיף "תפעול
          ותחזוקה", בנושא "קבלת שירות במסגרת האחריות" לעיל.
        </StyledLi>
        <StyledLi $margin={20}>
          על בעל הרכב לתקן ללא דיחוי ועל חשבונו כל פגיעה בצבע, חלודה, שיתוך
          ("קורוזיה") או נזק למיגון שמקורם בהזנחה (התחזוקה השוטפת הינה בתחום
          אחריות בעל הרכב) או בגורמים חיצוניים שנתגלו במהלך ביקורת.
        </StyledLi>
        <StyledLi $margin={20}>
          על בעל הרכב להודיע מיד לדלק מוטורס (או מוסך מורשה מטעמה) אם אלו פגיעות
          בצבע ו/או חלודה ו/או שיתוך ("קורוזיה") בחלק(י) מרכב של מכונית המאזדה
          שלו.
        </StyledLi>
      </StyledUl>
      <StyledHeaderSubtitle $margin={40}>
        קבלת שירות במסגרת האחריות
      </StyledHeaderSubtitle>
      <StyledBody>
        לשם קבלת שירות במסגרת האחריות יש לפנות עם הרכב — בשעות העבודה המקובלות —
        למוסך שירות מורשה מטעם דלק מוטורס ולהציג את חוברת האחריות. כל מוסך שירות
        מורשה מטעם דלק מוטורס יבצע את השירות במסגרת האחריות ובכפוף לתנאי
        האחריות.
      </StyledBody>
      <StyledHeaderSubtitle $margin={40}>אחריות מוגבלת</StyledHeaderSubtitle>
      <StyledBody>
        החבות של מאזדה במסגרת כתב אחריות זה מוגבלת אך ורק לתיקון של נזקי צבע
        ו/או שיתוך ("קורוזיה") במשטחים שמקורם בחומר לקוי או בעבודה לקויה. התיקון
        יבוצע במוסך שירות מורשה מטעם דלק מוטורס. למען הסר כל ספק, אחריות זו אינה
        כוללת במפורש כל הוצאה ישירה או עקיפה הקשורה להבאת הרכב למוסך השירות וכן
        אינה כוללת במפורש תשלום בגין אבדן השימוש ברכב המאזדה במהלך ביצוע
        התיקונים במסגרת האחריות.
      </StyledBody>
      <StyledHeaderSubtitle $margin={40}>תנאים אחרים</StyledHeaderSubtitle>
      <StyledBody>
        נושא "תנאים אחרים" מפרק א' לעיל ישים גם לאחריות זו.
      </StyledBody>
      <StyledHeaderH2 $position="right" $margin={40}>
        אחריות מוגבלת לפגיעות חירור עקב שיתוך חודר
      </StyledHeaderH2>
      <StyledBody>
        חברת מאזדה אחראית לכך כי לוחות הפח של המרכב ברכב המאזדה החדש — למעט ארגז
        נשיאת המטען (עבור רכב מסחרי) — יהיו חופשיים מפגמים שמקורם בחומר לקוי או
        בעבודה לקויה שיגרמו לחירור עובר (חלודה חודרת) מן הפנים כלפי חוץ, בכפוף
        לתנאים שלהלן.
      </StyledBody>
      <StyledBody>
        מוסך שירות מורשה מטעם דלק מוטורס יתקן או יחליף — ללא חיוב — כל לוח פח של
        המרכב אשר נפגע מחירור עקב פגמים שמקורם בחומר לקוי או בעבודה לקויה,
        ושנתגלו בתנאי שימוש רגילים.
      </StyledBody>
      <StyledHeaderSubtitle $margin={isDesktop ? 40 : 20}>
        ישימות האחריות המוגבלת לפגיעות חירור עקב שיתוך חודר
      </StyledHeaderSubtitle>
      <StyledBody>
        אחריות זו מתייחסת לרכב מתוצרת מאזדה שנרשם ומופעל בישראל. במהלך תקופת
        האחריות ניתן להעבירה לבעלים הבאים של הרכב. אם רכשת רכב מאזדה משומש, שלח
        את שובר "הודעה על רכישת רכב משומש" (בסוף חוברת "מידע לגבי אחריות ורישום
        טיפולים") אל אגף השירות של דלק מוטורס.
      </StyledBody>
      <StyledHeaderSubtitle $margin={40}>תקופת האחריות</StyledHeaderSubtitle>
      <StyledBody>
        תקופת האחריות היא 72 חודשים (ללא הגבלת מרחק נסיעה מצטבר) החל מן היום בו
        נמסר הרכב החדש לבעליו.
      </StyledBody>
      <StyledBody2 $fontSize={isDesktop ? 16 : 18} $margin={!isDesktop && 20}>
        סוגי הרכב מתוצרת מאזדה להם מוענק כיסוי במסגרת אחריות זו — רכב פרטי ורכב
        מסחרי.
      </StyledBody2>
      <StyledBody2 $fontSize={isDesktop ? 16 : 18} $margin={!isDesktop && 20}>
        האחריות מוגבלת לפגיעות חירור עקב שיתוך חודר ואינה מכסה את אחד או יותר
        מאלה
      </StyledBody2>
      <StyledUl $padding={20}>
        <StyledLi $margin={20}>
          כל חירור עקב שיתוך אשר מקורו בחומרים תעשייתיים הנישאים באוויר, בתאונה,
          בנזק מפגיעה חיצונית, בפגיעות אבנים, בשימוש ברכב שלא למטרות להן נועד
          ובביצוע שינויים ברכב.
        </StyledLi>
        <StyledLi $margin={20}>
          כל חירור עקב שיתוך אשר מקורו בפגיעות אופייניות של חול, ברד, הצפה,
          שיטפון, אבנים וכוח עליון אחר.
        </StyledLi>
        <StyledLi $margin={20}>
          כל חירור עקב שיתוך אשר נגרם לא כתוצאה מחומר לקוי או עבודה לקויה אלא
          עקב אי הענקת טיפול לרכב מאזדה בהתאם להנחיות המפורטות בסעיף 5 להלן
          ולהנחיות המפורטות בספר הנהג המסופק עם הרכב.
        </StyledLi>
        <StyledLi $margin={20}>
          כל חירור עקב שיתוך של חלק של רכב מתוצרת מאזדה שאינו לוח פח של המרכב.
          למען הסר ספק, הביטוי "לוח פח של המרכב" אינו כולל במפורש את כל הרכיבים
          המהווים חלק ממערכת הפליטה של רכב מתוצרת מאזדה.
        </StyledLi>
        <StyledLi $margin={20}>
          כל חירור עקב שיתוך בחלק(ים) של רכב מתוצרת מאזדה אשר תוקנו לא בהתאם
          להנחיות המפורטות במפרטי מאזדה המופיעים בספרות הטכנית הישימה של מאזדה
          ו/או תוך שימוש בחלקים שאינם חלקים מקוריים של מאזדה ו/או אשר תוקנו בידי
          גורם שאינו מוסך שירות מורשה מטעם דלק מוטורס.
        </StyledLi>
      </StyledUl>
      {!isDesktop && (
        <>
          <StyledHeaderSubtitle>חובות בעל הרכב</StyledHeaderSubtitle>
          <StyledBody>
            על בעל הרכב לטפל ברכב המאזדה כמפורט בנושא "טיפוח מראה המכונית" בספר
            הנהג.
          </StyledBody>
          <StyledUl $padding={20}>
            <StyledLi $margin={20}>
              על בעל הרכב לבצע במוסך שירות המורשה מטעם דלק מוטורס, על חשבונו,
              ביקורת של המרכב במסגרת ביצוע טיפול תחזוקה שנתי (12 חודשים).
            </StyledLi>
            <StyledLi $margin={20}>
              על בעל הרכב מוטלת החובה לשמור הוכחות המעידות כי בוצעו טיפולי
              תחזוקה וביקורת מרכב תקינים ובמועד ברכב המאזדה שלו. ביצוע הטיפולים
              יאושר בחוברת "מידע לגבי אחריות ורישום טיפולים" בחותמת ובחתימת מוסך
              השירות המורשה מטעם דלק מוטורס.
            </StyledLi>
            <StyledLi $margin={20}>
              על בעל הרכב לתקן ללא דיחוי ועל חשבונו כל פגיעת שיתוך ("קורוזיה")
              במרכב וכל נזק למיגון שמקורם באי-ביצוע תחזוקה או בגורמים חיצוניים
              שנתגלו במהלך הביקורת.
            </StyledLi>
            <StyledLi $margin={20}>
              על בעל הרכב להודיע בהקדם האפשרי למוסך מורשה מטעם דלק מוטורס אם
              גילה חירור בלוח פח של מרכב רכב המאזדה שלו.
            </StyledLi>
          </StyledUl>
          <StyledHeaderSubtitle>קבלת שירות במסגרת האחריות</StyledHeaderSubtitle>
          <StyledBody>
            לשם קבלת שירות במסגרת האחריות יש לפנות עם הרכב — בשעות העבודה
            המקובלות — למוסך שירות מורשה מטעם דלק מוטורס ולהציג את חוברת
            האחריות.
          </StyledBody>
          <StyledHeaderSubtitle>אחריות מוגבלת</StyledHeaderSubtitle>
          <StyledBody>
            החבות של מאזדה במסגרת כתב אחריות זה מוגבלת אך ורק לתיקון או להחלפה
            של חלקים שנתגלו בהם פגמים שמקורם בחומר לקוי או בעבודה לקויה. התיקון
            יבוצע במוסך שירות מורשה מטעם דלק מוטורס. למען הסר כל ספק, אחריות זו
            אינה כוללת במפורש כל הוצאה ישירה או עקיפה הקשורה להבאת הרכב למוסך
            השירות וכן אינה כוללת במפורש תשלום בגין אבדן השימוש ברכב המאזדה
            במהלך ביצוע התיקונים במסגרת האחריות.
          </StyledBody>
          <StyledHeaderSubtitle>תנאים אחרים</StyledHeaderSubtitle>
          <StyledBody>
            נושא "תנאים אחרים" מעמוד 2 לעיל ישים גם לאחריות זו.
          </StyledBody>
        </>
      )}
      <StyledHeaderH2 $position="right" $margin={40}>
        אחריות מוגבלת לחלפים מקוריים
      </StyledHeaderH2>
      <StyledHeaderSubtitle $margin={20}>
        ציוד עזר, חלקי חילוף, שינויים טכניים
      </StyledHeaderSubtitle>
      <StyledBody>
        אין אנו נוטלים על עצמנו אחריות כלשהי עבור חלקי חילוף, אביזרים, ציוד עזר
        או מכללים שלא אושרו על-ידי מאזדה ו/או שלא נרכשו כנגד חשבונית מס מקורית
        של חברת דלק מוטורס וכן אנו מסירים מעצמנו אחריות כלשהי עבור שינויים
        טכניים בלתי-מאושרים שבוצעו ברכב. חברת מאזדה אינה מסוגלת לבחון ולהעריך
        כנדרש את הבטיחות, ההתאמה והאמינות של מוצרי תעבורה זרים כנ"ל ולכן לא
        תוענק להם אחריות כלשהי.
      </StyledBody>
      <StyledBody>
        ניתן לרכוש חלקי חילוף מקוריים של מאזדה, אביזרים מקוריים של מאזדה ומוצרים
        אחרים המאושרים על-ידי מאזדה מחברת דלק מוטורס או מנציגים מאושרים מטעמה.
      </StyledBody>
      <StyledBody $margin={40}>
        לפני רכישה של חלקים או אביזרים וכן לפני ביצוע שינויים טכניים כלשהם מומלץ
        לפנות לייעוץ אל מוסך שירות מורשה מטעם דלק מוטורס. חברת מאזדה אחראית לכך
        כי חלקי-חילוף מקוריים של מאזדה יהיו חופשיים מפגמים שמקורם בחומר לקוי או
        בעבודה לקויה, בכפוף לתנאים שלהלן. אחריות זו מכסה חלקי חילוף מקוריים
        חדשים, מתוקנים ומשופצים של מאזדה שנמכרו והותקנו במוסך שירות מורשה מטעם
        דלק מוטורס. מוסך שירות מורשה מטעם דלק מוטורס יתקן או יחליף ללא חיוב כל
        חלק חילוף לשם תיקון של פגם כלשהו המכוסה באחריות.
      </StyledBody>

      <StyledHeaderSubtitle $margin={40}>
        ישימות האחריות המוגבלת לחלפים מקוריים
      </StyledHeaderSubtitle>
      <StyledBody>
        האחריות המוגבלת לחלקים מקוריים ישימה לחלקי חילוף מקוריים של מאזדה שנרכשו
        בדלק מוטורס כנגד חשבונית מקורית ואשר הותקנו ברכב כלשהו מתוצרת מאזדה
        שנרשם ומופעל בישראל. במהלך תקופת האחריות ניתן להעבירה לבעלים החדשים של
        הרכב.
      </StyledBody>
      <StyledHeaderSubtitle $margin={40}>חלקי חילוף</StyledHeaderSubtitle>
      <StyledBody>
        חלקי חילוף מכוסים למשך 12 החודשים הראשונים ללא הגבלת מרחק נסיעה, החל מן
        היום בו הותקנו במוסך שירות מורשה מטעם דלק מוטורס.
      </StyledBody>
      <StyledHeaderSubtitle $margin={40}>
        האחריות המוגבלת לחלקים מקוריים אינה מכסה
      </StyledHeaderSubtitle>
      <StyledUl $padding={20}>
        <StyledLi $margin={20}>
          חלקי חילוף מקורייים של מאזדה שהותקנו במסגרת האחריויות הישימות לרכב
          המאזדה שלך.
        </StyledLi>
        <StyledLi $margin={20}>
          נזק או שיתוך ("קורוזיה") שמקורם בתאונות, בשימוש ברכב לא למטרות להן
          נועד או בשינויי מבנה או דיגום.
        </StyledLi>
        <StyledLi $margin={20}>
          נזק או שיתוך במשטחים שמקורם בהשפעות סביבתיות כגון גשם חומצי, חומרים
          הנישאים באוויר (חומרים כימיים, שרף עצים, לשלשת צפורים וכד'), פגיעות
          אבנים, מלח, סיכוני הכביש, ברד, סופה, ברק, הצפה, שיטפון ואירועי כוח
          עליון אחרים.
        </StyledLi>
        <StyledLi $margin={20}>
          בלאי, שחיקה או בלייה עקב שימוש רגיל, אבדן צבע, דהייה, עיוות, טשטוש
          וכד'.
        </StyledLi>
        <StyledLi $margin={20}>
          חלקי חילוף מקוריים של מאזדה שהותקנו ברכב מתוצרת מאזדה שבוצע בו שינוי
          של קריאת האודומטר או שבו לא ניתן לקבוע בוודאות את מרחק הנסיעה המצטבר.
        </StyledLi>
        <StyledLi $margin={20}>
          חלקי חילוף מקוריים של מאזדה שנעשה בהם שימוש ביישומים שלא נועדו להם.
        </StyledLi>
        <StyledLi $margin={20}>
          כל חלק חילוף מקורי של מאזדה שאין הוכחה לגבי מועד התקנתו.
        </StyledLi>
      </StyledUl>
      <StyledHeaderSubtitle $margin={40}>
        קבלת שירות במסגרת האחריות
      </StyledHeaderSubtitle>
      <StyledBody>
        לשם קבלת שירות במסגרת האחריות על בעל הרכב לפנות עם המכונית - בשעות
        העבודה המקובלות - למוסך שירות מורשה מטעם חברת דלק מוטורס ולהציג את חוברת
        האחריות. כל מוסך שירות מורשה מטעם חברת דלק מוטורס יבצע את השירות במסגרת
        האחריות.
      </StyledBody>

      <StyledHeaderSubtitle $margin={40}>אחריות מוגבלת</StyledHeaderSubtitle>
      <StyledBody>
        החבות של מאזדה במסגרת כתב אחריות זה מוגבלת אך ורק לתיקון או החלפה של
        חלקים שנתגלו בהם נזקים שמקורם בחומר לקוי או בעבודה לקויה. התיקון יבוצע
        במוסך שירות מורשה מטעם דלק מוטורס. למען הסר כל ספק, אחריות זו אינה כוללת
        במפורש כל הוצאה ישירה או עקיפה הקשורה להבאת הרכב למוסך השירות וכן אינה
        כוללת במפורש תשלום בגין אבדן השימוש ברכב המאזדה במהלך ביצוע התיקונים
        במסגרת האחריות.
      </StyledBody>

      <StyledHeaderSubtitle $margin={40}>תנאים אחרים</StyledHeaderSubtitle>
      <StyledBody>
        נושא "תנאים אחרים" מפרק א' לעיל ישים גם לאחריות זו.
      </StyledBody>
      <StyledHeaderH2 $position="right" $margin={40}>
        מוקד שירות לקוחות
      </StyledHeaderH2>
      <StyledLink
        href={"tel:*2880"}
        $margin={10}
        $color="#4C607E"
        style={{ unicodeBidi: "plaintext" }}
      >
        *2880
      </StyledLink>
    </StyledWrapper>
  )
}

export default WarrantyBody
